module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container lexical"
  }, [_c('h4', {
    staticClass: "lexical-title"
  }, [_vm._v("\n          " + _vm._s(_vm.lexical.term_english) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "lexical-references"
  }, [_c('h5', [_vm._v("Target Language")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
    return _c('div', [(lang.id === _vm.lexical.lang_occu_id) ? _c('p', [_vm._v("\n                  " + _vm._s(lang.name) + "\n              ")]) : _vm._e()])
  }), _vm._v(" "), _c('h5', [_vm._v("Source Language")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
    return _c('div', [(lang.id === _vm.lexical.lang_orig_id) ? _c('p', [_vm._v("\n                  " + _vm._s(lang.name) + "\n              ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "lexical-references"
  }, [_c('h5', [_vm._v("Grammatical category")]), _vm._v(" "), _vm._l((_vm.apiGramCategories), function(gram) {
    return _c('div', [(gram.id === _vm.lexical.gramcategory_id) ? _c('p', [_vm._v("\n                  " + _vm._s(gram.long_name) + "\n              ")]) : _vm._e()])
  })], 2), _vm._v(" "), (_vm.lexical.meaning) ? _c('div', {
    staticClass: "lexical-references"
  }, [_c('h5', [_vm._v("Meaning")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.lexical.meaning)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.lexical.synonyms) ? _c('div', {
    staticClass: "lexical-references"
  }, [_c('h5', [_vm._v("Synonyms")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.lexical.synonyms)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.lexical.notes) ? _c('div', {
    staticClass: "lexical-references"
  }, [_c('h5', [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.lexical.notes)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.lexical.references) ? _c('div', {
    staticClass: "lexical-references"
  }, [_c('h5', [_vm._v("Bibliographic References")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.lexical.references)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lexical-author"
  }, [_vm._v("\n          Contribution from " + _vm._s(_vm.lexical.author_name) + " " + _vm._s(_vm.lexical.author_surname) + " (" + _vm._s(_vm.lexical.author_affiliation) + ")\n      ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a1ef2fd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LexicalUnit.vue
// module id = 160
// module chunks = 2